module.exports = __webpack_public_path__ + "static/media/36-iveco.c52f55f0.jpg";